import { render } from "./cryptoSelection.vue?vue&type=template&id=e10db170&scoped=true"
import script from "./cryptoSelection.vue?vue&type=script&lang=js"
export * from "./cryptoSelection.vue?vue&type=script&lang=js"

import "./cryptoSelection.vue?vue&type=style&index=0&id=e10db170&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e10db170"]])

export default __exports__